import { Form } from '@kocsistem/oneframe-react-bundle';
import { Popper } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useState } from 'react';

import CustomReactDatePicker from '../../../components/custom-react-datepicker';
import { get } from '../../../core/client';
import { useAppSelector } from '../../../store';

const IconSelect = () => (
    <svg className="icon-select" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 9L12 15L18 9" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const EditActionForm = ({
    definedActions,
    id,
    specialDateOptions,
    setStartOpenDatePicker,
    openStartDatePicker,
    actionTimeOptions,
    locationOptions,
    setEditedActionState,
    isEditedActionTouched,
}: any) => {
    const initialState = {
        managerDefinedSpecialDateId: '', //momentId
        userSpecialDateMainId: '',
        actionId: '',
        otherActionDescription: '',
        location: '',
        actionDate: null,
        actionTime: '',
        description: '',
        id: '',
        userId: '',
    };

    const [state, setState] = useState<any>(initialState);
    const [isEditedOtherShow, setIsEditedOtherShow] = useState<boolean>(false);
    const [isTouched] = useState<boolean>(false);
    const [planValue, setPlanValue] = useState<any>(null);
    const [editActionTime, setEditActionTime] = useState<any>(null);
    const [editLocation, setEditLocation] = useState<any>(null);
    const { words } = useAppSelector(state => state.localization);

    useEffect(() => {
        if (state.actionId && specialDateOptions.length > 0) {
            setIsEditedOtherShow(specialDateOptions.find(x => x.value === state.actionId).isOther);
        }
    }, [state.actionId]);

    useEffect(() => {
        const getActionDetail = async () => {
            await get<any>(`/specialdate-action/${id}`).then(res => {
                if (res.isSuccessful) {
                    const hour = res.result.actionHour;
                    const minute = res.result.actionMinute;
                    const actionMinute = minute || minute === 0 ? '0' + minute : 'Seçiniz';
                    const actionHour = hour ? (hour < 10 ? 0 + String(hour) + ':' : hour + ':') : '';
                    const actionTime = actionHour + actionMinute;
                    const actionDate = res.result.actionDate ? new Date(res.result.actionDate) : null;
                    setState({
                        userId: res.result.userId,
                        description: res.result.description,
                        location: res.result.location,
                        actionId: res.result.actionId,
                        actionTime: actionTime,
                        id: res.result.id,
                        actionDate: actionDate,
                        otherActionDescription: res.result.otherActionDescription,
                    });
                    setPlanValue(specialDateOptions.find(x => x.value === res.result.actionId));
                    setEditActionTime({ label: actionTime === '05:00' ? 'Seçiniz' : actionTime, value: actionTime });
                    setEditLocation({ label: res.result.location, value: res.result.location });
                    // updateEvent({ selectedDate: actionDate ? actionDate : null });
                }
            });
        };
        getActionDetail();
    }, [id]);

    useEffect(() => {
        setEditedActionState(state);
        // updateEvent({ selectedDate: state?.actionDate ? new Date(state?.actionDate) : null });
    }, [state]);

    const handleChange = (e: any) => {
        setState(prevState => ({
            ...prevState,
            [e.target.name]: e.target.value === undefined ? e.target.checked : e.target.value,
        }));
    };

    const speicalDayActionId = definedActions.map(item => item.speicalDayActionId);
    const index = speicalDayActionId.indexOf(id);

    const CustomPopper2 = function (props) {
        return <Popper {...props} className="modal-10" x-placement="bottom" />;
    };

    return (
        <>
            <div className="c-section-header">
                <h4>
                    {index + 1}. {words && words['WEB.editPlan']}
                </h4>
            </div>

            <Form onSubmit={() => null}>
                <div className="c-section-content">
                    <div className="c-section-content-01">
                        <div className="c-section-content-01-A">
                            <div className="c-unit-01">
                                <div className="c-unit-01-A">
                                    <FormControl variant="outlined" className="form-group-03">
                                        <label className="form-label">{words && words['WEB.planType']}</label>
                                        <Autocomplete
                                            fullWidth={true}
                                            noOptionsText={words && words['WEB.noDataInserted']}
                                            autoSelect={true}
                                            PopperComponent={CustomPopper2}
                                            closeIcon=""
                                            placeholder={state.actionId ? state.actionId : words && words['WEB.choose']}
                                            value={planValue}
                                            id="actionId"
                                            onChange={(e, val) => {
                                                setState(prevState => ({
                                                    ...prevState,
                                                    actionId: val ? val.value : '',
                                                }));
                                                setPlanValue(val);
                                            }}
                                            getOptionLabel={(option: any) => option && option.label && option.label}
                                            options={specialDateOptions ? specialDateOptions : []}
                                            className={
                                                isTouched && (!state.actionId || !state.otherActionDescription)
                                                    ? 'autocomplete-03 not-valid'
                                                    : 'autocomplete-03 '
                                            }
                                            renderInput={params => (
                                                <>
                                                    <TextField {...params} placeholder={words && words['WEB.choose']} />
                                                    <IconSelect />
                                                </>
                                            )}
                                        />
                                    </FormControl>
                                    {isEditedOtherShow && (
                                        <FormControl
                                            variant="outlined"
                                            className={isTouched && !state.otherActionDescription ? 'textfield-01 not-valid' : 'textfield-01'}>
                                            <label>{words && words['WEB.other']}</label>
                                            <TextField
                                                id="outlined-helperText"
                                                variant="outlined"
                                                name="otherActionDescription"
                                                value={state.otherActionDescription}
                                                onChange={handleChange}
                                            />
                                        </FormControl>
                                    )}
                                </div>
                                <div className="c-unit-01-B">
                                    <label className="form-label">
                                        {words && words['WEB.planDate']}
                                        <span className="form-opsiyonel">({words && words['WEB.optional']})</span>
                                    </label>
                                    <CustomReactDatePicker
                                        isTouched={isEditedActionTouched}
                                        name="actionDate"
                                        setState={setState}
                                        stateDate={state?.actionDate}
                                        isCreateActionPage
                                    />
                                </div>
                                <div className="c-unit-01-C">
                                    <FormControl variant="outlined" className="form-group-03">
                                        <label>
                                            {words && words['WEB.planTime']}
                                            <span className="form-opsiyonel">({words && words['WEB.optional']})</span>
                                        </label>
                                        <Autocomplete
                                            fullWidth={true}
                                            autoSelect={true}
                                            PopperComponent={CustomPopper2}
                                            value={editActionTime}
                                            getOptionSelected={(option: any) => option && option.label && option.label}
                                            closeIcon=""
                                            id="actionTime"
                                            onChange={(e, val) => {
                                                setState(prevState => ({
                                                    ...prevState,
                                                    actionTime: val ? val.label : '',
                                                }));
                                                setEditActionTime(val);
                                            }}
                                            getOptionLabel={(option: any) => option && option.label && option.label}
                                            options={actionTimeOptions ? actionTimeOptions : []}
                                            className="autocomplete-03 "
                                            renderInput={params => (
                                                <>
                                                    <TextField {...params} placeholder={words && words['WEB.choose']} />
                                                    <IconSelect />
                                                </>
                                            )}
                                        />
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                        <div className="c-section-content-01-B">
                            <div className="c-unit-01">
                                <div className="c-unit-01-A">
                                    <FormControl variant="outlined" className="form-group-03">
                                        <label className="form-label">
                                            {words && words['WEB.planPlace']}
                                            <span className="form-opsiyonel">({words && words['WEB.optional']})</span>
                                        </label>
                                        <Autocomplete
                                            fullWidth={true}
                                            autoSelect={true}
                                            PopperComponent={CustomPopper2}
                                            closeIcon=""
                                            id="location"
                                            value={editLocation}
                                            onChange={(e, val) => {
                                                setState(prevState => ({
                                                    ...prevState,
                                                    location: val ? val.value : '',
                                                }));
                                                setEditLocation(val);
                                            }}
                                            getOptionLabel={(option: any) => option && option.label && option.label}
                                            options={locationOptions ? locationOptions : []}
                                            className={isTouched && !state.location ? 'autocomplete-03 not-valid' : 'autocomplete-03 '}
                                            renderInput={params => (
                                                <>
                                                    <TextField {...params} placeholder={words && words['WEB.choose']} />
                                                    <IconSelect />
                                                </>
                                            )}
                                        />
                                    </FormControl>
                                </div>
                                <div className="c-unit-01-B">
                                    <div className="c-unit-01-B-content form-group-03">
                                        <label>
                                            {words && words['WEB.note']} <span className="form-opsiyonel">({words && words['WEB.optional']})</span>
                                        </label>
                                        <textarea
                                            value={state.description}
                                            onChange={handleChange}
                                            className="textarea-01"
                                            name="description"
                                            placeholder={words && words['WEB.write'] + '...'}></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </>
    );
};

export default EditActionForm;
